<template>
    <nav class="navbar navbar-expand-sm navbar-dark bg-dark">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarTogglerDemo01">
            <a class="navbar-brand" href="#">PORTAL DEMO</a>
            <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
                <router-link to="/resultado" class="nav-link">Casos</router-link>
                <router-link to="/contacto" class="nav-link">Contactos</router-link>
                <router-link to="/cuenta" class="nav-link">Cuentas</router-link>
            </ul>
            <button class="nav-link" @click="logout">Logout</button>
        </div>
</nav>
</template>
<script>


export default {
    methods: {
        logout(){

        }
    }
}
</script>